import React from 'react'
import { TbPrompt } from "react-icons/tb";
import './IconStyles.css';

export const PromptsIcon = (props) => (
    <div style={{minWidth: "1.75em"}}>
    <TbPrompt
        color={props.color ? props.color : undefined}
                   size={props.size ? props.size : "1.25em"}
        // className="globaliconstyles"
    />
    </div>
)